import {Component} from 'react'
import PropTypes from 'prop-types'
import { clone } from '../../../shared/services/lodashInJS.js'

import LinkAs from '../LinkAs/LinkAs.jsx'

import {generate} from '../../routes.js'
import queryWatcher from '../QueryWatcher/QueryWatcherConnect.js'

import './Skills.scss'

class Skills extends Component {
  static propTypes = {
    list: PropTypes.array,
    className: PropTypes.string,
    noHistory: PropTypes.bool,
    secondary: PropTypes.bool,
    shy: PropTypes.bool,
    outline: PropTypes.bool,
  }

  static defaultProps = {
    className: '',
    noHistory: false,
    linkName: 'search',
    secondary: false,
    shy: false,
    outline: false,
  }

  generateLink = (object) => {
    const keywords = [object.name]
    let search = {}
    if(!this.props.noHistory && this.props.queryString.keywords) {
      const urlKeywords = clone(this.props.queryString.keywords)

      if(Array.isArray(urlKeywords)) {
        for(let i=0; i<urlKeywords.length; i++) {
          if(keywords.indexOf(urlKeywords[i]) === -1) {
            keywords.push(urlKeywords[i])
          }
        }
      } else {
        keywords.push(urlKeywords)
      }

      search = clone(this.props.queryString)
    }

    search.keywords = keywords

    return generate({
      name: this.props.linkName,
      search,
    })
  }

  render() {
    let list = this.props.list
    if (this.props.length) {
      list = this.props.list.slice(0, this.props.length)
    }

    return (
      <div className={`skill-list ${this.props.className}`}>
        {
          (this.props.forceNoLink && (
            list.map((object, offset) => (
              <button key={offset} type="button" className={`btn btn-${this.props.outline ? "outline-" : ""}${this.props.secondary ? "secondary" : this.props.shy ? "shy" : "primary"} btn-sm break-inside btn-auto-width`}>
                {object.name}
              </button>
            ))
          ))
            ||
          (list.map((object, offset) => {
            const link = this.generateLink(object)

            return <LinkAs
              key={offset}
              className={`btn btn-${this.props.secondary ? "secondary" : "primary"} btn-sm break-inside btn-auto-width`}
              freelance={link}
              do={link}
              notConnected={generate({name: 'register-do'})}
            >
              {object.name}
            </LinkAs>
          }))
        }
      </div>
    )
  }
}

export default queryWatcher(Skills)
